import fieldTypes from '../../../../../../enums/FieldTypes';
import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import county from '../../defaultFieldDefinitions/County';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import streetName from '../../defaultFieldDefinitions/StreetName';
import postCode from '../../defaultFieldDefinitions/PostCode';
import * as max from '../../max-length-validators';
import PredictionsByField from '../../PredictionsByField';
import * as required from '../../required-validators';
import SpecialCharFieldValidators from '../../SpecialCharFieldValidators';
import validateAutocompleteField from '../../validateAutocompleteField';

const cities = PredictionsByField.city('AE');
const states = PredictionsByField.county('AE');

const fieldDefinitionAEDefault = [
  addressee,
  {
    ...postCode,
    required: false,
    validate: [SpecialCharFieldValidators.postcode, max.lengthPostCode(16)],
  },
  companyName,
  nameNumber,
  streetName,
  addressLine2,
  {
    name: 'townCity',
    label: 'checkout.delivery.address.field.label.town.text',
    required: true,
    element: fieldTypes.AUTOCOMPLETE,
    placeholder: 'checkout.delivery.address.field.placeholder.townCity.autoComplete',
    predictions: cities,
    validate: [required.townCity, max.lengthAddress(35), validateAutocompleteField(cities, 'townCity')],
  },
  county,
];

const fieldDefinitionAEWithStateAutocomplete = [
  addressee,
  {
    ...postCode,
    required: false,
    validate: [SpecialCharFieldValidators.postcode, max.lengthPostCode(16)],
  },
  companyName,
  nameNumber,
  streetName,
  addressLine2,
  {
    name: 'townCity',
    label: 'checkout.delivery.address.field.label.town.text',
    required: true,
    element: fieldTypes.AUTOCOMPLETE,
    placeholder: 'checkout.delivery.address.field.placeholder.townCity.autoComplete',
    predictions: cities,
    validate: [required.townCity, max.lengthAddress(35), validateAutocompleteField(cities, 'townCity')],
  },
  {
    name: 'county',
    label: 'checkout.address.field.label.county.text',
    required: true,
    element: fieldTypes.AUTOCOMPLETE,
    placeholder: 'checkout.delivery.address.field.placeholder.county.autoComplete',
    predictions: states,
    validate: [required.state, max.lengthAddress(35), validateAutocompleteField(states, 'state')],
  },
];

const autocompleteConditions = window.start.settings.should_use_autocomplete_for_state;
const FieldDefinitionAE = autocompleteConditions ? fieldDefinitionAEWithStateAutocomplete : fieldDefinitionAEDefault;

export default FieldDefinitionAE;
